var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid pl-0"},[_c('ShowAlert'),_c('SidebarComponent',{staticClass:"h-100"}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }